import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { _className, ComponentSync, Grid, LL_V_L, TS_Input } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { ConfigKeyFE_DiseasesViewsTagId, ConfigKeyFE_SystemsTagIds, ModuleFE_Reference, ModuleFE_Tag, ModuleFE_Variable, QScrollWrapper } from '@app/hcs-frontend';
import { BadImplementationException, Filter, sortArray } from '@nu-art/ts-common';
import './Renderer_CriticalityTable.scss';
import { CriticalityLabelMap } from '@app/dp-shared';
import { ModuleFE_DiseaseProfile, ModuleFE_MultiVar } from '@app/dp-frontend';
export class Renderer_CriticalityTable extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.pathway = nextProps.pathway;
        state.sort ??= {
            type: 'criticality',
            dir: 'dsc',
        };
        return state;
    }
    // ######################## Logic ########################
    setSort = (type) => {
        //If no sort or sort type is not the same
        if (this.state.sort?.type !== type)
            return this.setState({ sort: { type, dir: 'asc' } });
        //Sort type is the same
        if (this.state.sort.dir === 'asc') {
            return this.setState({ sort: { type, dir: 'dsc' } });
        }
        this.setState({ sort: undefined });
    };
    getDDs = () => {
        const pathway = this.state.pathway;
        const complaintsTagId = this.getComplaintsTagId();
        if (!complaintsTagId)
            return [];
        return ModuleFE_DiseaseProfile.cache.filter(dp => {
            return !!ModuleFE_MultiVar.cache.find(mv => {
                return mv.diseaseProfileId === dp._id
                    && pathway.variableIds.includes(mv._firstVarId)
                    && !!mv.variables[0].tagIds.find(tagGroup => tagGroup.value.includes(complaintsTagId));
            });
        });
    };
    getComplaintsTagId = () => {
        const dvTagId = ConfigKeyFE_DiseasesViewsTagId.get();
        const complaintsTag = ModuleFE_Tag.cache.find(tag => tag.tagIds.includes(dvTagId) && tag.label.toLowerCase() === 'complaints');
        if (!complaintsTag)
            this.logError('Could not find complaints tag');
        return complaintsTag?._id;
    };
    getSortedDDData = () => {
        const sort = this.state.sort;
        const dds = this.getDDs();
        let ddData = dds.map(dd => this.generateDDData(dd));
        if (this.state.filterTerm) {
            const filter = new Filter(data => [data.label]);
            ddData = filter.filter(ddData, this.state.filterTerm);
        }
        if (!sort)
            return ddData;
        return sortArray(ddData, dd => sort.type === 'criticality' ? dd.criticality : dd[sort.type].toLowerCase(), sort.dir === 'dsc');
    };
    generateDDData = (dd) => {
        const variable = ModuleFE_Variable.cache.unique(dd.variableId);
        if (!variable)
            throw new BadImplementationException(`Could not get variable for id ${dd.variableId}`);
        const systemsTagId = ConfigKeyFE_SystemsTagIds.get()[0];
        const systemGroup = variable.tagIds.find(group => group.key === systemsTagId);
        const tag = ModuleFE_Tag.cache.unique(systemGroup?.value[0]);
        const icdRef = ModuleFE_Reference.cache.filter(ref => ref.type === 'icdCode' && variable.referenceIds.includes(ref._id))[0];
        return {
            id: dd._id,
            label: dd.label,
            criticality: dd.criticality,
            icd: icdRef?.data.id ?? '',
            system: tag?.label ?? '',
        };
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { className: 'pathway__criticality-table', children: [this.renderFilter(), this.renderTableHeaders(), this.renderTableBody()] });
    }
    renderFilter = () => {
        return _jsx(TS_Input, { type: 'text', value: this.state.filterTerm, onChange: value => this.setState({ filterTerm: value }) });
    };
    // ######################## Render - Table Headers ########################
    renderTableHeaders = () => {
        return _jsxs(Grid, { className: 'pathway__criticality-table__headers', children: [this.renderTableHeader('DD Name', 'label'), this.renderTableHeader('SnomedId', 'icd'), this.renderTableHeader('System', 'system'), this.renderTableHeader('Criticality', 'criticality')] });
    };
    renderTableHeader = (header, type) => {
        const iconClass = _className(type === this.state.sort?.type ? this.state.sort.dir : undefined);
        return _jsxs("div", { className: 'criticality-table__header', onClick: () => this.setSort(type), children: [_jsx("div", { className: 'criticality-table__header__text', children: header }), _jsx(ICONS.sortArrows.component, { className: iconClass })] });
    };
    // ######################## Render - Table Body ########################
    renderTableBody = () => {
        const dds = this.getSortedDDData();
        return _jsx(QScrollWrapper, { children: _jsx(Grid, { className: 'criticality-table', children: dds.map(dd => {
                    return _jsxs(React.Fragment, { children: [_jsx("div", { className: 'criticality-table__data', children: dd.label }), _jsx("div", { className: 'criticality-table__data', children: dd.icd || '-' }), _jsx("div", { className: 'criticality-table__data', children: dd.system || '-' }), _jsx("div", { className: 'criticality-table__data', children: dd.criticality ? CriticalityLabelMap[dd.criticality] : '-' })] }, dd.id);
                }) }) });
    };
}
//# sourceMappingURL=Renderer_CriticalityTable.js.map